"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by davit.petrosyan on 20/12/2018.
 */
var SSOConfig = /** @class */ (function () {
    function SSOConfig() {
    }
    SSOConfig.SSO_SERVICE_URL_KEY = 'sso-service-url';
    SSOConfig.SSO_LOGIN_URL = '/saml/login';
    SSOConfig.SSO_PRE_LOGIN_URL = '/ssoprelogin';
    SSOConfig.SSO_DEEP_URL_QUERY_PARAM = 'DeepUrl=';
    SSOConfig.SSO_HOME_URL_QUERY_PARAM = 'RedirectUrl=';
    return SSOConfig;
}());
exports.SSOConfig = SSOConfig;
//# sourceMappingURL=sso-config.js.map